/**
 * Төлбөрийн хуваалтын дүрэм — сервер, вэб, гар утас ГУРВУУЛАА.
 *
 * ЯАГААД НЭГ ГАЗАР
 *  Дүрэм нь МӨНГӨНИЙХ: «нийлбэр нь захиалгын дүнтэй таарна». Гурван
 *  газар гурван хувилбар бичвэл нэг нь тоймлож, нөгөө нь Float-оор
 *  харьцуулж эхэлнэ — тэр өдөр касс тэнцэхгүй болно. Сервер нь эцсийн
 *  шүүгч; клиентүүд ИЖИЛ функцээр урьдчилан шалгаад товчоо идэвхгүй
 *  болгоно, ингэснээр ажилтан маягт бөглөж дуусаад 422 авахгүй.
 *
 * ⚠️ Харьцуулалт `Decimal`-аар. Мөнгө Float болохгүй (CLAUDE.md дүрэм 3):
 *    0.1 + 0.2 ≠ 0.3 бөгөөд 1,558,888₮-ийн хуваалт 0.01₮-өөр зөрөхөд
 *    захиалга бүхэлдээ татгалзагдана.
 */
import { Decimal } from 'decimal.js';
/** Зээлийн апп заавал шаардах цорын ганц хэлбэр. */
export const CREDIT_APP_METHOD = 'CREDIT_APP';
/**
 * Хуваалт хүчинтэй эсэх. Зөв бол `null`, эс бөгөөс АНХНЫ алдааны код.
 *
 * `totalMnt` нь захиалгын НИЙТ дүн (хөнгөлөлт хасагдсаны дараах).
 */
export function checkPaymentSplit(parts, totalMnt) {
    if (parts.length === 0)
        return 'EMPTY';
    for (const p of parts) {
        if (new Decimal(p.amountMnt || 0).lessThanOrEqualTo(0))
            return 'AMOUNT_NOT_POSITIVE';
        if (p.method === CREDIT_APP_METHOD && !p.providerId)
            return 'PROVIDER_REQUIRED';
        if (p.method !== CREDIT_APP_METHOD && p.providerId)
            return 'PROVIDER_NOT_ALLOWED';
    }
    const sum = parts.reduce((a, p) => a.plus(new Decimal(p.amountMnt || 0)), new Decimal(0));
    if (!sum.equals(new Decimal(totalMnt)))
        return 'SUM_MISMATCH';
    return null;
}
/**
 * `orders.payment` — ХУРААНГУЙ утга.
 *
 * Нэг хэлбэр бол тэр нь, хэд хэдэн бол `MIXED`. Хоёр мөр ижил
 * хэлбэртэй байж болно (жишээ: хоёр өөр карт) — тэр нь `MIXED` БИШ.
 *
 * ⚠️ Хувь зээл орсон бол `INSTALLMENT` — эхний 10% өөр хэлбэрээр ч гэсэн
 *    жагсаалтад «Хувь зээл» гэж харагдах нь «Холимог»-оос мэдээлэлтэй.
 *    Солилцооны баримт мөн адил `EXCHANGE` (зөрүүг бэлнээр төлсөн ч).
 */
export function paymentSummaryMethod(parts) {
    const marked = parts.find((p) => p.method === 'INSTALLMENT') ?? parts.find((p) => p.method === EXCHANGE_METHOD);
    if (marked)
        return marked.method;
    const methods = new Set(parts.map((p) => p.method));
    return methods.size === 1 ? parts[0].method : 'MIXED';
}
/**
 * Солилцооны төлбөрийн хэлбэр — буцаасан гутлын үнэ шинэ худалдан
 * авалтад тооцогдсон хэсэг. БЭЛЭН МӨНГӨ БИШ (касст орохгүй).
 */
export const EXCHANGE_METHOD = 'EXCHANGE';
/**
 * Солилцооны зөрүү (2026-10-03). `oldTotalMnt` — буцаах мөрийн төлсөн дүн,
 * `newTotalMnt` — шинэ баримтын төлөх дүн.
 *
 *   credit = min(хуучин, шинэ)   extra = шинэ − credit   refund = хуучин − credit
 *
 * extra, refund хоёрын нэг нь ҮРГЭЛЖ 0. Орлого энд бодогдохгүй: тайлан
 * буцаагдсан мөрийг хасаж, шинэ мөрийг тоолно — цэвэр нь шинэ гутлын үнэ.
 */
export function exchangeSettlement(oldTotalMnt, newTotalMnt) {
    const oldTotal = new Decimal(oldTotalMnt);
    const newTotal = new Decimal(newTotalMnt);
    const creditMnt = Decimal.min(oldTotal, newTotal);
    return {
        creditMnt,
        extraMnt: newTotal.minus(creditMnt),
        refundMnt: oldTotal.minus(creditMnt),
    };
}
//# sourceMappingURL=payment.js.map